export default "__VITE_ASSET__DadT6S3B__"